<template>
  <div
    class="ui-alert mb-2 flex items-center gap-2 overflow-hidden text-sm"
    :class="`variant-${variant}`"
  >
    <div v-if="!hideIcon" class="ui-alert-icon">
      <slot name="icon">
        <v-icon v-if="variant === 'info'">mdi-information-outline</v-icon>
        <v-icon v-if="variant === 'warning'">mdi-alert-outline</v-icon>
        <v-icon v-if="variant === 'danger'">mdi-alert-circle-outline</v-icon>
        <v-icon v-if="variant === 'success'">mdi-check-circle-outline</v-icon>
      </slot>
    </div>
    <div class="ui-alert-content w-full min-w-0 max-w-full">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
type IAlertVariants = 'info' | 'warning' | 'danger' | 'success';

interface Props {
  variant?: IAlertVariants;
  hideIcon?: boolean;
}

withDefaults(defineProps<Props>(), {
  variant: 'danger',
  hideIcon: false,
});
</script>

<style scoped lang="scss">
.ui-alert {
  border-radius: 0.5rem;
  padding: 0.5rem;
  font-weight: 500;
  border: 2px solid transparent;
  border-color: theme('colors.grey.200');
  color: theme('colors.grey.900');

  &.variant-info {
    border-color: theme('colors.blue.200');
    background-color: theme('colors.blue.50');

    .ui-alert-icon {
      :deep(.v-icon) {
        color: rgb(var(--v-theme-primary, 25, 118, 210));
      }
    }
  }

  &.variant-warning {
    border-color: theme('colors.orange.200');
    background-color: theme('colors.orange.50');

    .ui-alert-icon {
      :deep(.v-icon) {
        color: theme('colors.orange.400');
      }
    }
  }

  &.variant-danger {
    border-color: theme('colors.red.200');
    background-color: theme('colors.red.100');

    .ui-alert-icon {
      :deep(.v-icon) {
        color: rgb(var(--v-theme-error, 176, 0, 32));
      }
    }
  }

  &.variant-success {
    border-color: theme('colors.green.200');
    background-color: theme('colors.green.100');

    .ui-alert-icon {
      :deep(.v-icon) {
        color: theme('colors.green.600');
      }
    }
  }
}

.ui-alert-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
</style>
